import React, { useState, useEffect } from 'react';
import HarvestHorizonHero from '../components/HarvestHorizonHero';
import '../styles/HarvestHorizonHero.css';

const AgConvergeNew = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0
  });

  useEffect(() => {
    const eventDate = new Date('2026-11-17T09:00:00');

    const updateCountdown = () => {
      const now = new Date();
      const diff = eventDate - now;

      if (diff > 0) {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 60000);

    return () => clearInterval(timer);
  }, []);

  const registrationUrl = 'https://cvent.me/kY4WxR';

  const handleRegistration = () => {
    window.open(registrationUrl, '_blank');
  };

  return (
    <div className="agconverge-page">
      <HarvestHorizonHero timeLeft={timeLeft} onRegister={handleRegistration} />
      {/* Add more sections below as we build them out */}
    </div>
  );
};

export default AgConvergeNew;